import { toast } from "react-toastify";

export const startDownloadNotification = (documentName) =>
  toast.loading(`${documentName} is downloading...`, {
    position: "top-right",
    closeButton: true,
  });

export const completeDownloadNotification = (notificationId, documentName, options = {}) =>
  toast.update(notificationId, {
    render: options.onClick ? `${documentName} downloaded. Tap to open.` : `${documentName} downloaded.`,
    type: "success",
    isLoading: false,
    autoClose: 3000,
    closeButton: true,
    onClick: options.onClick,
  });

export const failDownloadNotification = (notificationId, documentName) =>
  toast.update(notificationId, {
    render: `Could not download ${documentName.toLowerCase()}.`,
    type: "error",
    isLoading: false,
    autoClose: 3000,
    closeButton: true,
  });
